import { HttpClient } from '@angular/common/http';
import { debounceTime } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { ChangeDetectorRef, Component, DoCheck, OnInit, OnDestroy, inject } from '@angular/core';

import { UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';

import { SharedService } from 'src/app/core/services/shared.service';
import { VendorService } from 'src/app/core/services/vendor.service';
import { Fields } from 'src/app/shared/models/candidateprofile-genmodel';
import { MatFormField, MatLabel, MatInput, MatError } from '@angular/material/input';

@Component({
  selector: 'app-input',
  standalone: true,
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  imports: [MatFormField, ReactiveFormsModule, MatLabel, MatInput, MatError],
})
export class InputComponent implements OnInit, DoCheck, OnDestroy {
  private http = inject(HttpClient);
  private cdRef = inject(ChangeDetectorRef);
  private sharedService = inject(SharedService);
  private vendorService = inject(VendorService);

  field: Fields;
  group: UntypedFormGroup;
  requiredBool: boolean;
  entityId = localStorage.getItem('companyHiringTypeId');
  selectedRole = localStorage.getItem('selectedRole');
  debounceSubscribe: Subscription;
  errorMessage: string;
  // gstNo: any;
  jobDetails: any;

  ngOnInit() {
    if (
      this.field &&
      (this.field?.name == 'emailId' || this.field?.name == 'govIdNo' || this.field?.name == 'panNumber') &&
      this?.field.url
    ) {
      this.group
        .get(this.field.name)
        .valueChanges.pipe(debounceTime(1500))
        .subscribe((data) => {
          console.log(data, 'email');
          if (this.group.get(this.field.name).valid) {
            // this.field.url="http://10.47.50.242:8181/validate/validateEmail?email={0}&entityId={1}"
            if (this.selectedRole == 'ROLE_ECMS_ALL') {
              // For emailId, use POST with body
              if (this.field.name == 'emailId') {
                const reqBody = {
                  email: this.group.get(this.field.name).value,
                  companyHiringId: this.entityId,
                };

                // Remove query parameters from URL
                const cleanUrl = this.field.url.split('?')[0];

                this.http.post<any>(cleanUrl, reqBody).subscribe(
                  (data) => {
                    if (data?.message == 'Email Id already exists') {
                      this.group.get(this.field.name).setErrors({ serviceError: false });
                      this.group.get(this.field.name).setErrors({ duplicate: true });
                    } else if (data?.message === 'Applied job is invalid. Please apply for another job') {
                      // Handle invalid job
                    } else {
                      this.group.get(this.field.name).setErrors(null);
                      this.errorMessage = '';
                    }
                  },
                  (error) => {
                    console.log(error);
                    this.group.get(this.field.name).setErrors({ duplicate: false });
                    this.group.get(this.field.name).setErrors({ serviceError: true });
                  },
                );
              }
              // For other fields (govIdNo, panNumber), use GET with params
              else {
                const IdExistUrl = this.field.url
                  ?.replace('{0}', this.group.get(this.field.name).value)
                  .replace('{1}', this.entityId.toString());

                this.http.get<any>(IdExistUrl).subscribe(
                  (data) => {
                    if (data?.isValid == 0 && (this.field.name == 'panNumber' || this.field.name == 'govIdNo')) {
                      this.errorMessage = data?.message;
                    } else if (data?.message === 'Applied job is invalid. Please apply for another job') {
                      // Handle invalid job
                    } else {
                      this.group.get(this.field.name).setErrors(null);
                      this.errorMessage = '';
                    }
                  },
                  (error) => {
                    console.log(error);
                    this.group.get(this.field.name).setErrors({ duplicate: false });
                    this.group.get(this.field.name).setErrors({ serviceError: true });
                  },
                );
              }
            } else {
              const mobileNum = this.group.get('contactNo').value;
              if (this.field && this.field?.name == 'emailId' && mobileNum) {
                this.vendorService._currentDetails.subscribe((data: any) => {
                  // console.log(this.genericTemplate, "job details");
                  this.jobDetails = data;
                });
                const IdExistUrl = this.field.url;
                console.log(IdExistUrl, 'email url');
                const countryCode = this.group.get('countryCode').value;
                const validateObj = {
                  email: this.group.get(this.field.name).value,
                  publicationId: this.jobDetails?.publicationId,
                  companyHiringTypeId: localStorage.getItem('companyHiringTypeId'),
                  contactNo: '+' + countryCode + '-' + mobileNum,
                  sourceId: this.jobDetails?.sourceId,
                };
                // "contactNo": "+91-9933223111",
                this.http.post<any>(IdExistUrl, validateObj).subscribe(
                  (data) => {
                    if (data?.status == 'Failure') {
                      let validMessageObj = [];
                      // this.field.validations.push({ message: "Applied job is invalid. Please apply for another job.", name: "invalidjob", value: "invalidjob" });
                      const respObj = data?.message.includes('.');
                      if (respObj) {
                        validMessageObj = this.field.validations.filter((dataFields) =>
                          dataFields?.message
                            ?.trim()
                            .replace(/\.$/, '')
                            .toLowerCase()
                            .includes(data?.message?.trim().replace(/\.$/, '').toLowerCase()),
                        );
                      } else {
                        validMessageObj = this.field.validations.filter((dataFields) =>
                          dataFields?.message?.trim().toLowerCase().includes(data?.message?.trim().toLowerCase()),
                        );
                      }
                      const errorName = validMessageObj[0]?.name;
                      this.group.get(this.field.name).setErrors({ [errorName]: true });
                      if (
                        !this.group.get('contactNo').hasError('pattern') &&
                        !this.group.get('contactNo').hasError('required') &&
                        !this.group.get('contactNo').hasError('minlength') &&
                        !this.group.get('contactNo').hasError('maxlength')
                      ) {
                        this.group.get('contactNo').setErrors(null);
                      }
                    } else {
                      this.group.get(this.field.name).setErrors(null);
                      if (
                        !this.group.get('contactNo').hasError('pattern') &&
                        !this.group.get('contactNo').hasError('required') &&
                        !this.group.get('contactNo').hasError('minlength') &&
                        !this.group.get('contactNo').hasError('maxlength')
                      ) {
                        this.group.get('contactNo').setErrors(null);
                      }
                      // this.group.get("contactNo").setErrors(null);
                      this.errorMessage = '';
                    }
                  },
                  (_error) => {
                    this.group.get(this.field.name).setErrors({ serviceError: true });
                  },
                );
              }
            }
          } else {
            this.errorMessage = '';
          }
        });
    }
  }

  ngDoCheck() {
    if (
      this.field.name == 'exInfoscianNumber' ||
      this.field.name == 'otherDegreeName' ||
      this.field.name == 'otherUniversityName'
    ) {
      if (this.field.isHidden) {
        this.group.get(this.field.name).removeValidators(Validators.required);
        this.group.get(this.field.name).updateValueAndValidity();
        this.requiredBool = false;
        this.cdRef.detectChanges();
      } else {
        this.group.get(this.field.name).setValidators(Validators.required);
        this.group.get(this.field.name).updateValueAndValidity();
        // console.log(this.field,"exx");
        this.requiredBool = true;
        this.cdRef.detectChanges();
      }
    }
  }

  restrictSpclChar(eventValue, field) {
    if (field.name != 'emailId') {
      return this.sharedService.restrictSpclChar(eventValue);
    }
  }

  rstrctSpclCharPaste(eventValue, field) {
    if (field.name != 'emailId') {
      return this.sharedService.rstrctPasteSpclChar(eventValue);
    }
  }

  ngOnDestroy() {
    this.debounceSubscribe?.unsubscribe();
  }
}
